import React, { } from 'react';
import { useDispatch } from 'react-redux';
import _, { first } from 'lodash';
import { useHistory } from 'react-router-dom';
import { Box, Tab, Table, TableBody, TableCell, TableHead, TableRow, Tabs, Typography } from '@mui/material';
import Matching, { MatchingConstants, MatchingModel } from '../MatchingPreview/MatchingConstants';
import './MarketingMatchingConfig.scss';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

const MarketingMatchingConfig: React.FunctionComponent = () => {
    let dispatch = useDispatch();
    let history = useHistory();

    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const renderMatchingTable = (matchingItems: MatchingModel[]) => {
        let headerRows = _.map(matchingItems, (item) => {
            return item.name;
        });

        return <>
            <div className='wrapper'>
                <Table className="datatable marketing-matching-config-table">
                    <TableHead>
                        <TableRow className="datatable-head">
                            <TableCell
                                className="datatable-cell-header"
                            >
                            </TableCell>
                            {
                                _.map(headerRows, (headerName) => {
                                    return <TableCell
                                        className="datatable-cell-header"
                                    >
                                        {headerName}
                                    </TableCell>
                                })
                            }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            _.map(matchingItems, (matchingItem) => {
                                return <TableRow>
                                    <TableCell>{matchingItem.name}</TableCell>
                                    {
                                        _.map(headerRows, (headerName) => {
                                            let colValue = "0";
                                            if (matchingItem.name == headerName) {
                                                colValue = "1";
                                            }

                                            if (_.indexOf(matchingItem.first, headerName) > -1) {
                                                colValue = "1";
                                            }

                                            if (_.indexOf(matchingItem.second, headerName) > -1) {
                                                colValue = "2";
                                            }

                                            return <TableCell>{colValue}</TableCell>
                                        })
                                    }
                                </TableRow>
                            })
                        }

                    </TableBody>
                </Table>
            </div>
        </>
    }

    return <>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                <Tab label="Under 18" />
                <Tab label="18 to 38" />
                <Tab label="Over 38" />
            </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
            {renderMatchingTable(MatchingConstants.MatchingUnder18)}
        </TabPanel>
        <TabPanel value={value} index={1}>
            {renderMatchingTable(MatchingConstants.Matching18To38)}
        </TabPanel>
        <TabPanel value={value} index={2}>
            {renderMatchingTable(MatchingConstants.MatchingOver38)}
        </TabPanel>
    </>
};

export default MarketingMatchingConfig;